const Consts = {
    MESSAAGE_DIALOG_WIDTH: '19rem',
    VALIDITY: 'validity',
    INSTANCE: 'instance'
}

export default Consts;